import { Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from "@mui/material";
import type { FC } from "react";
import { useState } from "react";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import LabelledCheckbox from "../../components/labelledCheckbox/LabelledCheckbox";

interface DialogProps {
  readonly open: boolean;
  readonly title?: string;
  readonly isTagPopular?: boolean;
  readonly tagName: string;
  readonly onChange: (name: string, isPopular: boolean) => Promise<void>;
  readonly onClose: () => void;
}

const EditTagDialog: FC<DialogProps> = ({ open, title, tagName, isTagPopular, onChange, onClose }) => {
  const [name, setName] = useState(() => tagName);
  const [isPopular, setIsPolular] = useState(() => isTagPopular ?? false);

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{title ?? "Edytuj tag"}</DialogTitle>
      <DialogContent>
        <Stack
          direction="column"
          sx={{
            marginTop: 2,
          }}
        >
          <TextField label="Nazwa" value={name} onChange={(e) => setName(e.target.value)} fullWidth />
          {isTagPopular !== undefined && (
            <LabelledCheckbox label="Najpopularniejsze" checked={isPopular} onChange={setIsPolular} />
          )}
        </Stack>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onClose} />
        <AsyncLoadingButton
          disabled={(name.trim().length === 0 || name === tagName) && isPopular == isTagPopular}
          onClick={async () => {
            await onChange(name, isPopular);
            onClose();
          }}
        >
          Zapisz
        </AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default EditTagDialog;
